import { useEffect, useState } from 'react';
import classNames from 'classnames';

import styles from './Stepper.module.css';

const Step = ({
  isActive,
  isComplete,
  isCurrent,
  resourcesUrl,
  step,
  stepNumber







}: {isActive: boolean;isComplete: boolean;isCurrent: boolean;resourcesUrl: string;step: string;stepNumber: number;}) => {
  const stepClasses = classNames(
    styles.step,
    isActive ? styles[`step--active`] : ''
  );

  const content = isComplete ?
  <img
    alt=""
    className={styles.complete}
    src={`${resourcesUrl}/assets/img/subscribe/tick.png`} /> :


  <span aria-hidden="true">{stepNumber}</span>;


  return (
    <li
      aria-current={isCurrent}
      aria-label={`progress step ${stepNumber}, ${step}${isComplete ? '. Step is complete' : ''}`}
      className={stepClasses}
      data-label={step}>

			{content}
		</li>);

};

export const Stepper = ({
  activeStep,
  isActiveStepComplete,
  resourcesUrl,
  stepperName,
  steps






}: {activeStep: string;isActiveStepComplete?: boolean;resourcesUrl: string;stepperName: string;steps: string[];}) => {
  const [progress, setProgress] = useState('0%');

  const totalSteps = steps.length - 1;
  const activeSteps = steps.findIndex((step) => {
    return step === activeStep;
  });

  useEffect(() => {
    setProgress(`${activeSteps / totalSteps * 100}%`);
  }, [activeSteps, steps, totalSteps]);

  const style = { '--progress': progress } as React.CSSProperties;

  return (
    <div aria-label={stepperName} role="group">
			<ol className={styles['stepper-container']} style={style}>
				{steps.map((step, index) =>
        <Step
          isActive={index <= activeSteps}
          isComplete={
          index < activeSteps ||
          index === activeSteps && !!isActiveStepComplete
          }
          isCurrent={index === activeSteps}
          key={`step-${step}-${index}`}
          resourcesUrl={resourcesUrl}
          step={step}
          stepNumber={index + 1} />

        )}
			</ol>
		</div>);

};